var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "gl-square-btn btn-grey-outline",
      on: { click: _vm.goBackward }
    },
    [_vm._v("\n    Назад\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }